import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";
import { config, logoutFunc } from "./Functions";
import { store } from "..";

let BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_BASE_URL
    : process.env.REACT_APP_PROD_BASE_URL;

const axiosCRMinstance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
});

export const refreshToken = async (): Promise<any> => {
  const resp = await axios.post(
    `${BASE_URL}users/refresh_token/`,
    {
      refresh_token: localStorage.getItem("refresh_token"),
    },
    await config()
  );
  return resp.data.token;
};

axiosCRMinstance.interceptors.request.use(
  async (config: AxiosRequestConfig<any>) => {
    config.headers = config.headers || {};
    const authToken: string | null = localStorage.getItem("authToken");
    if (authToken) {
      config.headers.Authorization = `Token ${authToken}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

axiosCRMinstance.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (error: AxiosError) => {
    const originalRequest = error.config || {};
    if (error.response && error.response.status === 403) {
      const newToken = await refreshToken();
      if (
        newToken?.token === undefined ||
        newToken?.token === "" ||
        newToken?.token === null
      ) {
        logoutFunc(store.dispatch).then(() => {
          window.location.reload();
        });
        return Promise.reject(error);
      } else {
        if (newToken && originalRequest.headers) {
          localStorage.setItem("authToken", newToken?.token);
          localStorage.setItem("refresh_token", newToken?.refresh_token);
          originalRequest.headers.Authorization = `Token ${newToken?.token}`;
          return axiosCRMinstance(originalRequest);
        }
      }
    }
  }
);

export default axiosCRMinstance;
